interface RouteConfig {
  path: string
  clean?: string
}

interface RoutesConfig {
  [key: string]: RouteConfig
}

export const Routes: RoutesConfig = {
  Home: { path: "/" },
  Dashboard: { path: "/dashboard" },
  SignIn: { path: "/signin" },
  Profile: { path: "/profile" },
  Register: { path: "/Register" },
  ForgotPassword: { path: "/ForgotPassword" },
  Search: { path: "/search", clean: "/search/" },
  VehicleDetails: { path: "/vehicleDetails/:id", clean: "/vehicleDetails/" },
  VehicleVisits: { path: "/vehicleVisits" },
  ResetPassword: { path: "/ResetPassword" },
  Categories: { path: "/Categories", clean: "/categories/" },
  Stages: { path: "/Stages", clean: "/stages/" },
  Settings: { path: "/settings", clean: "/settings/" },
  Customers: { path: "/customers", clean: "/customers/" },
  CustomerDetails: {
    path: "/customers/details/:id",
    clean: "/customers/details/",
  },
  Places: { path: "/places", clean: "/places" },
  PlaceDetails: { path: "/places/:placeId", clean: "/places/" },
  SelectOrganization: { path: "/SelectOrganization" },
  chat: { path: "/chat/:chatId", clean: "/chat/" },
  visitReport: {
    path: "/reports/visitReport/",
    clean: "/reports/visitReport/",
  },
  placesByAgentsReport: {
    path: "/reports/placesByAgents/",
    clean: "/reports/placesByAgents/",
  },
  agentVisitsReport: {
    path: "/reports/agentVisits/",
    clean: "/reports/agentVisits/",
  },
  reportDemo: {
    path: "/reports/demo/",
    clean: "/reports/demo/",
  },
  newPlacesReport: {
    path: "/reports/newPlaces/",
    clean: "/reports/newPlaces/",
  },
  Agents: { path: "/agents", clean: "/agents/" },
  AgentDetails: { path: "/agents/:id", clean: "/agents/" },
}
